<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import type { Snippet } from 'svelte';

  type Tone = 'indigo' | 'cyan' | 'red' | 'amber' | 'slate';
  type Size = 'sm' | 'md' | 'lg';

  interface Props {
    tone?: Tone;
    size?: Size;
    rounded?: 'xl' | 'full';
    children?: Snippet;
  }

  let { tone = 'indigo', size = 'md', rounded = 'xl', children }: Props = $props();

  const sizes: Record<Size, string> = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-14 h-14',
  };

  const tones: Record<Tone, string> = {
    indigo: 'bg-gradient-to-br from-indigo-500 to-purple-500 shadow-indigo-500/40',
    cyan: 'bg-gradient-to-br from-cyan-500 to-blue-500 shadow-cyan-500/20',
    red: 'bg-red-500 shadow-red-500/30',
    amber: 'bg-amber-500 shadow-amber-500/30',
    slate: 'bg-slate-700 shadow-slate-900/40',
  };
</script>

<span
  class="inline-flex items-center justify-center text-white shadow-lg rounded-{rounded} {sizes[size]} {tones[tone]}"
>
  {@render children?.()}
</span>
